import { createApi } from '@reduxjs/toolkit/query/react';
import { IUser } from '../../models/auth';
import { baseQueryWithAuthRedirect } from './rtk';

export const usersAPI = createApi({
  reducerPath: 'usersAPI',
  baseQuery: baseQueryWithAuthRedirect,
  tagTypes: ['Users'],
  endpoints: builder => ({
    getUsers: builder.query<IUser[], string>({
      query: () => ({
        url: 'users/',
      }),
      providesTags: [{ type: 'Users', id: 'current' }],
    }),
    createUser: builder.mutation<IUser, IUser>({
      query: (args: IUser) => ({
        url: `users/`,
        method: 'POST',
        body: args,
      }),
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
    updateUser: builder.mutation<IUser, IUser>({
      query: (args: IUser) => ({
        url: `users/${args.id}`,
        method: 'PUT',
        body: args,
      }),
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
    deleteUser: builder.mutation({
      query: (id: string) => ({
        url: `users/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
  }),
});
export const {
  useGetUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = usersAPI;
